import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsInt, IsNumber, IsPositive, Max, Min } from "class-validator";

@Exclude()
export class VehicleTypeCosts {
    @IsInt()
    @IsDefined()
    @Expose()
    public vehicleType: number;

    @Min(0)
    @IsNumber()
    @IsDefined()
    @Expose()
    public amortisationMinimalPrice: number;

    @IsNumber()
    @IsPositive()
    @IsDefined()
    @Expose()
    public amortisationPrice: number;

    @IsNumber()
    @IsPositive()
    @IsDefined()
    @Expose()
    public consumptionPrice: number;

    @Min(0)
    @IsNumber()
    @IsDefined()
    @Expose()
    public locationMinimalPrice: number;

    /**
     * The minimal price drivers are willing to accept for their engagement, regardless of trip distance
     */
    @Min(0)
    @IsNumber()
    @IsDefined()
    @Expose()
    public tripMinimumPrice: number;

    /**
     * Coefficient allows for dynamic adjustments to the standard fee based on various conditions or criteria, ensuring flexibility in pricing models.
     * It is expressed as a percentage and stored as a decimal number subtracted from 1, eg. 23% fee coefficient is stored as 0.77.
     * @example 0.77
     */
    @Min(0)
    @Max(1)
    @IsNumber()
    @IsDefined()
    @Expose()
    public feeCoefficient: number;
}
